module.exports = __webpack_public_path__ + "img/0603-j.4ea34d2d.svg";